/**
 * Variable de enviroment para definir el endpoint a donde se enviaran las
 * peticiones graphql
 *  */
export const API_URL = 'https://cronun.herokuapp.com/graphql';
// export const API_URL = 'https://cronunapp.df.r.appspot.com/graphql';
export const SUBJECTS_INDEX = 'prod_SUBJECTS';
export const ALGOLIA_ADMIN_API_KEY = '359c844c80db27c8d69437fd90a15e2f';
export const ALGOLIA_APP_ID = 'GPUBZKRO9O';
